import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';

import update from 'react-addons-update';
import xtend from 'xtend';

import Loader from '../../../../common/components/notifications/Loader';
import Locations from '../../../../metadata/components/locations/Locations';
import Location from '../../../../metadata/components/locations/Location';
import MetadataFilter from '../../../../metadata/components/MetadataFilter';

import MetadataPaginationMixin from '../../../mixins/MetadataPaginationMixin';

var EventLocations = createReactClass({

    mixins: [
        MetadataPaginationMixin
    ],

    propTypes: {
        actions: pt.shape({
            editEvent: pt.func.isRequired
        }).isRequired,
        data: pt.array.isRequired
    },

    getInitialState: function () {
        return xtend({
            isTyping: false,
            term: '',
            edited: false,
            edits: ''
        }, this.getDefaultPaginationState());
    },

    save: function () {
        var final = null;

        this.props.data.map(function (location) {
            /*
                1. If this location is found in this.state.edits (added/unchanged)
                2. If not already added to the final array of locationIDs (as that's what the API takes)
             */
            if (this.state.edits == location.locationName) {
                final = location.locationID;
            }
        }, this);

        this.props.actions.editEvent({
            locationID: final
        });
    },

    revert: function () {
        this.setState(this.getInitialState());
    },

    /*
        State Functions
     */
    termChanged: function (value) {
        this.setState({
            isTyping: false,
            term: value.toLowerCase()
        });
    },

    /*
        handles De-bouncing
     */
    handleTypingStarted: function () {
        this.setState({
            isTyping: true
        });
    },

    /*
     * transferState:
     * 	This injests the current state of the assigned locations as makes them
     * 	the active state here so any incoming changes via events can be omitted
     * 	while the user stages changes to the assigned location listing
     */
    transferState: function () {
        if (!this.state.edited) {
            this.setState(function (state, props) {
                return {
                    edited: true,
                    edits: props.event.locationName
                };
            });
        }
    },

    assignLocationToEvent: function (index) {
        this.transferState();

        this.setState(function (state, props) {
            var location = props.data[index];
            return {
                edits: update(state.edits, {$set: location['locationName']})
            };
        });
    },

    remove: function (index) {
        this.transferState();

        var updates = [];
        updates = {$set: ''};

        this.setState(function (state) {
            return {
                edits: update(state.edits, updates)
            };
        });
    },

    /*
        Helper Functions
     */
    getAssignedLocation: function () {
        return this.state.edited ? this.state.edits : this.props.event.locationName;
    },


    /*
        Render Functions
     */
    render: function () {
        if (this.props.isResolving) return <Loader message="Fetching"/>;

        var listing;
        var paginatedData = [];

        if (this.state.isTyping) {
            listing = <Loader message='Filtering'/>;
        } else {

            paginatedData = this.getPaginatedData();

            listing = <Locations
                locations={paginatedData}
                term={this.state.term}
                mode="event"
                assigned={this.getAssignedLocation()}
                assignLocationToEvent={this.assignLocationToEvent}
            />;
        }

        var paginationElement = this.renderPagination();

        return (
            <div>
                <div className="callout clearfix">
                    <div className="col-sm-8">
                        <MetadataFilter termChanged={this.termChanged} isTyping={this.handleTypingStarted}/>
                    </div>

                    <div className="col-sm-4 tab-actions">
                        <button className="btn btn-default" disabled={!this.state.edited} onClick={this.revert}><i className="fa fa-undo"/> Revert Changes</button>
                        <button className="btn btn-success" disabled={!this.state.edited} onClick={this.save}><i className="fa fa-save"/> Save Changes</button>
                    </div>
                </div>

                <hr/>

                <div className="col-sm-6">
                    <label>Assigned Location</label>
                    <div className="clearfix">
                        {this.renderAssigned()}
                    </div>
                </div>

                <div className="col-sm-6">
                    <label>Available Locations</label>

                    <div className="row">
                        {paginationElement}
                    </div>

                    <div className="clearfix">
                        {listing}
                    </div>
                </div>
            </div>
        );
    },

    renderAssigned: function () {
        var assigned = this.getAssignedLocation();
        var location;

        if (!assigned || !assigned.length) return (<div className="alert alert-info">
            <p>No Locations assigned to this Event</p>
        </div>);

        for (var i = 0; i < this.props.data.length; i++) {
            var l = this.props.data[i];
            if (l.locationName == assigned) {
                // var cloned = JSON.parse(JSON.stringify(l));
                location = <Location {...this.props}
                    key={'location-' + l.locationID + '-event-' + i}
                    remove={this.remove}
                    mode="event"
                    isAssignedLocation={true}
                    location={l}/>;
                break;
            }
        }

        // this.props.data.response.clientLocations.map(function (l, index) {
        // }, this);

        return location;
    }
});

export default EventLocations;
